import React, { useState, useEffect } from 'react';
import { I_Group } from '@Redux/detail/Group/interfaces';
import * as Icons from '@components/Common/Icons';
import Flag from '@components/Common/Flag';
import { getIsCompared, handleCompare } from '@utils/compare';
import FBimg from './imgs/fb.jpg';
import Lineimg from './imgs/line.jpg';
import styles from './styles.module.scss';

const GroupHead = () => {
    const { travelinfo } = document.getElementById('detailPagePara')!.dataset!;
    const { GroupInfo, ProductType }: I_Group = JSON.parse(travelinfo!);
    const {
        TourDays,
        GoDate,
        NormGroupID,
        TourName,
        GroupID,
        TravelType,
        IsVip,
        VipOrigPrice,
        Price,
        TagList,
    } = GroupInfo;
    const [isCompared, setIsCompared] = useState<boolean>(false);

    // 一進頁面時，如果有 Login，則判斷有沒有加入收藏 & 比較
    useEffect(() => {
        (async () => {
            await getIsCompared({
                TourDays,
                GoDate: GoDate,
                NormGroupID,
                NormGroup: TourName,
                GroupID: GroupID,
                TravelType,
                setIsCompared,
            });
        })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const socialShare = (media: 'fb' | 'line') => {
        // 將網址當參數時，需用 encodeURIComponent 編碼
        const productLink = encodeURIComponent(window.location.href);

        media === 'fb'
            ? window.open(
                  `https://www.facebook.com/sharer.php?u=${productLink}`,
                  'facebook-popup',
                  'height=640,width=640'
              )
            : window.open(
                  `https://social-plugins.line.me/lineit/share?url=${productLink}`,
                  'lineshare',
                  'width=640,height=640'
              );
    };

    return (
        <div className={styles.group_notes}>
            <Flag ProductType={ProductType} TagList={TagList} />
            <div className={styles.group_notes_links}>
                <div
                    className={styles.group_notes_link}
                    onClick={(e) => {
                        e.preventDefault();
                        handleCompare({
                            TravelType,
                            Price: IsVip ? VipOrigPrice : Price,
                            TourDays,
                            NormGroup: TourName,
                            GoDate: GoDate,
                            GroupID: GroupID,
                            NormGroupID,
                            isCompared,
                            setIsCompared,
                        });
                    }}
                >
                    <Icons.Compare fill={isCompared ? '#f03742' : '#999'} />
                    <span style={{ color: isCompared ? '#f03742' : '#999' }}>比較</span>
                </div>
                <a href="#" className={styles.group_notes_share} onClick={() => socialShare('fb')}>
                    <img src={FBimg} alt="FB 連結" />
                </a>
                <a
                    href="#"
                    className={styles.group_notes_share}
                    onClick={() => socialShare('line')}
                >
                    <img src={Lineimg} alt="Line 連結" />
                </a>
            </div>
        </div>
    );
};

export default GroupHead;
